import { TFunction } from "i18next";
import React, { useEffect } from "react";
import { useContactForm } from "../hooks/useContactForm";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  t: TFunction<"translation", undefined>;
}

const ContactForm: React.FC<Props> = ({ t, ...props }) => {
  const { formData, handleChange, handleSubmit, isSubmitting, formStatus } =
    useContactForm({
      name: "",
      email: "",
      message: "",
      contactMethod: "",
      contactValue: "",
    });

  // Отправка события при изменении formStatus
  useEffect(() => {
    if (formStatus.type === "success") {
      window.fbq("track", "Lead");
      window.fbq("track", "SubmitContact", { status: "success" });
    } else if (formStatus.type === "error") {
      window.fbq("track", "SubmitContact", { status: "error" });
    }
  }, [formStatus]);

  return (
    <div className="w-full h-auto" {...props}>
      <form onSubmit={handleSubmit}>
        <div className="mb-6">
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            {t("form_name")}
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            className="w-full px-4 py-3 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            {t("form_email")}*
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder={t("form_email")}
            className="w-full px-4 py-3 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
            required
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="contactMethod"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            {t("form_contact_method")}*
          </label>
          <select
            id="contactMethod"
            name="contactMethod"
            value={formData.contactMethod}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
            required
          >
            <option value="" disabled>
              {t("form_select_contact_method")}
            </option>
            <option value="telegram">Telegram</option>
            <option value="whatsapp">WhatsApp</option>
          </select>
        </div>
        {formData.contactMethod && (
          <div className="mb-6">
            <label
              htmlFor="contactValue"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              {formData.contactMethod === "telegram"
                ? t("form_telegram_username")
                : t("form_whatsapp_number")}
              *
            </label>
            <input
              type={formData.contactMethod === "whatsapp" ? "tel" : "text"}
              id="contactValue"
              name="contactValue"
              value={formData.contactValue}
              onChange={handleChange}
              placeholder={
                formData.contactMethod === "telegram"
                  ? "@username"
                  : "+1234567890"
              }
              className="w-full px-4 py-3 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
              required
            />
          </div>
        )}
        <div className="mb-6">
          <label
            htmlFor="message"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            {t("form_message")}*
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder={t("form_message")}
            className="w-full px-4 py-3 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500"
            required
          />
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-3 text-lg font-semibold text-white bg-gray-900 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-700"
        >
          {isSubmitting ? t("form_submitting") : t("form_button")}
        </button>

        {formStatus.type === "success" && (
          <div className="mt-4 p-4 text-sm text-green-700 bg-green-100 rounded-md">
            {t("form_success_message")}
          </div>
        )}

        {formStatus.type === "error" && (
          <div className="mt-4 p-4 text-sm text-red-700 bg-red-100 rounded-md">
            {t("form_error_message")}
          </div>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
